import React from 'react';
import { motion } from 'framer-motion';
import Tilt from 'react-parallax-tilt';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project, index }) => {
  const fadeIn = (direction = "", type = "spring", delay = 0.1, duration = 1) => {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { delay, duration } },
    };
  };

  const github = 'https://i.pinimg.com/originals/b5/1b/78/b51b78ecc9e5711274931774e433b5e6.png';

  return (
  <motion.div variants={fadeIn('up', 'spring', index * 0.5, 0.75)}>
  <div>
    <Link key={project.name} to={`/detailproject/${project.name}`}>
      <Tilt className='bg-[#000] p-5 rounded-2xl sm:w-[340px] w-full h-full shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer'>
        <div className="relative w-full h-[230px]">
          <img
            src={project.image}
            alt={project.name}
            className='w-full h-full object-cover rounded-2xl'
          />
          <div className="absolute inset-0 flex justify-end m-3 card-img_hover">
            <div
              className="bg-gradient-to-r from-black to-black w-10 h-10 rounded-full flex justify-center items-center cursor-pointer hover:scale-110 transition-transform duration-300"
              onClick={() => window.open(project.source_code_link, "_blank")}
            >
              <img src={github} className='bg-white object-contain rounded-3xl' alt="GitHub" />
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="mt-5 min-h-[140px] flex flex-col justify-between">
          <h3 className="text-white text-xl font-semibold">{project.name}</h3>
          <p className="text-gray-400 text-sm line-clamp-6">
            {project.description}
          </p>
        </div>

        {/* Tags */}
        <div className="mt-4 flex flex-wrap gap-2">
          {project.tags.map((tag) => (
            <p key={tag.name} className={`text-[14px] ${tag.color}`}>
              #{tag.name}
            </p>
          ))}
        </div>
      </Tilt>
    </Link>

    
  </div>
</motion.div>

  );
};

export default ProjectCard;
